var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 123,
    viewBox: "0 0 89 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 0,
    y: 0,
    width: 89,
    height: 123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "k-2",
    "data-name": "k",
    transform: "translate(44.5 93.5)",
    fill: "rgba(255,255,255,0.2)",
    fontSize: 86,
    fontFamily: "PingFangSC-Regular, PingFang SC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43,
    y: 0
  }, "\u5E84")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChine);
export default __webpack_public_path__ + "static/media/chine.17a165f2e55aaacd706480501cd182c0.svg";
export { ForwardRef as ReactComponent };